import { getNavigationConnectionProperty } from "../../../user-agent-fallbacks/navigation-connection";

export const isIdleLoadingDesired = () =>
  getNavigationConnectionProperty()?.saveData === false;
